import { AbilityBuilder, createMongoAbility } from "@casl/ability";
import { isArray, isObject } from "lodash";
import { features as fe } from "keys";
import { roleNames } from "keys/roles";
import secretStorage from "./secretStorage";

export const canAccessField = (field, ability) => {
    if (Array.isArray(field.permissions) && field.permissions.length > 0) {
        const result = field.permissions.some(({ role, feature }) => {
            const can = ability.can(role, feature);
            console.log("checking:", role, feature, "=>", can);
            return can;
        });

        console.log("FINAL RESULT:", result);
        return result;
    }

    if (field.role && field.feature) {
        return ability.can(field.role, field.feature);
    }

    return true;
};


export const permissions = {
    edit: "edit", // צריך לבטל אותו ולסדר את כל ההרשאות שיש לו בנתיים

    read: "read",        // קריאה בלבד
    write: "write",      // יצירה + עריכה
    manage: "manage"     // הכל
}

function isObjectNotArray(item) {
    return isObject(item) && !isArray(item);
}

const defineAbilityFor = (roleIndex) => {
    const user = secretStorage.getItem("user")
    const { user_data, is_superuser, features: featurePermissions = [] } = user || {}

    // ולידצייה על מבנה של אוביקט משתמש המאוחסן
    // בstorage
    if (isObjectNotArray(user_data))
        secretStorage.clean()

    const features = featurePermissions?.concat(user_data?.[roleIndex]?.features)
    const role = user_data?.[roleIndex]?.role_name
    const { can, cannot, build } = new AbilityBuilder(createMongoAbility)

    cannot(permissions.read, ["transcription", "audio-cutting"])

    can(permissions.read, 'all')
    cannot(permissions.manage, [
        roleNames.super_user,
        roleNames.student,

        fe.school_setup
    ])

    can(permissions.manage, role)

    cannot(permissions.write, [
        fe.training_assessment, // האפשרות ליצור בתעתוק מבדקי לימוד לבודקת, נמצא תחת כותרת עמודה "צור גרסת בודק"

        fe.school_setup,
        "test_taker",
        "user-status-cell",
        "edit-user-cell",
        "write__assessment",
        "write__test_taker",
        "battery",
        "edit-testTaker",
        "upload-audio",
        "generate-coupon-code",
        "write-upload-assessment",
        "write-record-assessment"
    ])

    // לסדר!!
    cannot('create', [
        "to-be-developed",
        "user-status-cell",
        "edit-user-cell",
        "write__assessment",
        "write__test_taker",
        "battery",
        "edit-testTaker",
        "upload-audio",
        "generate-coupon-code",
        "write-upload-assessment",
        "write-record-assessment"
    ])

    cannot(permissions.read, [
        // viewsets
        fe.category,
        fe.test_taker,
        fe.battery,
        fe.score_method,
        fe.user_role,
        fe.learning_center,
        fe.admin_assessment,
        fe.practicate_assessments,
        fe.general_performance_review,

        fe.school_setup,

        fe.user_password,
        fe.download_audio,
        fe.redo_assessment,

        // עמודות בטבלה
        fe.reading_quality_cell,

        // טאבים
        fe.assessments_activity__tab,


        "delete-class",
        "transcription_system",
        "training_assessments",
        "tutorials",
        "battery-performance-cell",
        "to-be-developed",
        "admin_assessment",
        "admin-assessments",
        "preform-assessment-perview",
        "user-affiliation-cell",
        "progress-graph",
        "visibility-status-cell",
        "ticket-menu",
        "select-row",
        "preview-mode",
        "assessment-preview",
        "reading_assessment_def_id__cell",
        "ticket-priority",
        "activated-by-cell",
        "newsletter",
        "perform-assessments-page",
        "child-development",
        "grade-of-allocation",
        "user",
        "users",
        "assessment-id",
        "ungroup-assessment",
        "next-assessment-btn",
        "student-label",
        "toolbar-columns-button",
        "dashboard",
        "assessments-for-testTaker",
        "col_ID",
        "marking-words",
        "admin_assessment",
        "voice-lab",
        "linguistic-lab",
        "perform-assessments",
        "assessments",
        "test-takers",
        "toolbar-actions",

        // screens in client
        fe.assessment_library
    ])

    features?.forEach((feature) => {
        feature && can(feature.permission, feature.feature)
    })


    if (role == "parent" || role == "student")
        cannot("read", ["toolbar"])


    // עבור משתמשים עם הרשאה של בודקת - מתעתעקת
    if (role == "apprentice_tester" || role == "experienced_tester" || role == "beginner_tester")
        can("manage", ["tester"])


    // עבור משתמשים עם הרשאה של תלמיד
    if (role == "student") {
        can(permissions.read, ["student-dashboard"])
    }

    if (is_superuser) {
        can("manage", ["all", "super-user"])
        cannot(permissions.manage, ["student"])
    }

    return build()
};

export default defineAbilityFor
